export { default } from './ActivityInfo';

